<div class="org-tree-select">
  <div #trigger cdkOverlayOrigin="origin" class="org-tree-trigger" tabindex="0" role="button"
    [class.disabled]="disabled"
    [attr.aria-expanded]="isOpen" [attr.aria-disabled]="disabled" aria-haspopup="listbox"
    (click)="toggle()"
    (keydown.enter)="toggle()"
    (keydown.space)="toggle(); $event.preventDefault()">
    <span class="org-tree-label">{{ displayLabel }}</span>
    @if (disabled) {
      <i class="material-icons org-tree-lock">lock</i>
    }
    @if (!disabled) {
      <span class="org-tree-arrow" [class.open]="isOpen"></span>
    }
  </div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayHasBackdrop]="false"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayPanelClass]="'org-tree-overlay-panel'"
    (overlayOutsideClick)="closePanel()"
    (detach)="closePanel()">
    <div class="org-tree-panel" role="listbox">
      <input type="text" class="org-tree-search" [(ngModel)]="searchText"
        [placeholder]="'Search...' | translate"
        (click)="$event.stopPropagation()" />
        <div class="org-tree-scroll">
          @if (!hideNullOption) {
            <div class="org-tree-item" [class.selected]="selectedId == null" tabindex="0" role="option"
              [attr.aria-selected]="selectedId == null"
              (click)="select(null)"
              (keydown.enter)="select(null)"
              (keydown.space)="select(null); $event.preventDefault()">
              {{ placeholder | translate }}
            </div>
          }
          <ng-container *ngTemplateOutlet="nodeTree; context: { list: filteredNodes, level: 0 }">
          </ng-container>
          <ng-template #nodeTree let-list="list" let-level="level">
            @for (node of list; track trackByOrgId($index, node)) {
              <span [ngClass]="'org-item-' + level">
                <span class="org-tree-item" [ngClass]="'child-level-' + level" [class.selected]="selectedId === node.id"
                  [class.disabled-item]="disabledIdSet.has(node.id)"
                  tabindex="0" role="option" [attr.aria-selected]="selectedId === node.id"
                  [attr.aria-disabled]="disabledIdSet.has(node.id)"
                  (click)="select(node)"
                  (keydown.enter)="select(node)"
                  (keydown.space)="select(node); $event.preventDefault()">
                  {{ node.name }}
                </span>
                @if (node.children?.length) {
                  <ng-container *ngTemplateOutlet="nodeTree; context: { list: node.children, level: level + 1 }">
                  </ng-container>
                }
              </span>
            }
          </ng-template>
        </div>
      </div>
    </ng-template>
  </div>
